module.exports = __webpack_public_path__ + "img/wordqhuan.2efcf977.svg";